import { useSyncExternalStore } from "react";

/**
 * Whether a media query matches, kept current as the window changes.
 *
 * False where there is no window to ask, so a test or a first render gets the
 * plainer of the two things a component might draw.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => {};
      const list = window.matchMedia(query);
      list.addEventListener("change", notify);
      return () => list.removeEventListener("change", notify);
    },
    () =>
      typeof window !== "undefined" && window.matchMedia
        ? window.matchMedia(query).matches
        : false,
    () => false,
  );
}
